import HorizontalNavbar from './HorizontalNavbar';

export default HorizontalNavbar;
